const KEY = "ag7_pending_referral";

export function captureReferralFromUrl() {
  const code = new URLSearchParams(window.location.search).get("ref");
  if (code && /^[A-Za-z0-9_-]{6,80}$/.test(code)) {
    window.localStorage?.setItem(KEY, code);
  }
  return pendingReferralCode();
}

export function pendingReferralCode() {
  try { return window.localStorage?.getItem(KEY) || ""; }
  catch { return ""; }
}

export function clearPendingReferralCode() {
  try { window.localStorage?.removeItem(KEY); }
  catch { /* storage is optional */ }
}